import styled from "styled-components";
import type React from "react";
import { useMemo } from "react";
import { TotalVisitsWidgetWrapper } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/TotalVisitsWidgetWrapper";
import { OrganicVSPaidWidgetWrapper } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/OrganicVSPaidWidgetWrapper";
import { BrandedNonBrandedWidgetWrapper } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/BrandedNonBrandedWidgetWrapper";
import type { ISearchOverviewTopWidgetContainer } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";

export const TopPageWidgetsRow = styled.div`
    display: grid;
    grid-template-columns: 34% 34% 32%;
`;

export const SearchOverviewTopWidgetSingleContainer: React.FunctionComponent<ISearchOverviewTopWidgetContainer> = (
    props,
) => {
    const { subtitleFilters, apiParams, isTotal } = props;
    const { webSource, country, key, isWindow, isWWW, to, from } = apiParams;

    const apiParamsObj = useMemo(() => {
        return {
            country,
            from,
            to,
            includeSubDomains: !isWWW,
            isWindow,
            keys: key,
            timeGranularity: "Monthly",
            webSource,
        };
    }, [country, from, to, isWWW, isWindow, key, webSource]);

    return (
        <div>
            <TopPageWidgetsRow>
                <TotalVisitsWidgetWrapper
                    apiParams={apiParams}
                    apiParamsObj={apiParamsObj}
                    subtitleFilters={subtitleFilters}
                />
                <OrganicVSPaidWidgetWrapper
                    apiParams={apiParams}
                    apiParamsObj={apiParamsObj}
                    subtitleFilters={subtitleFilters}
                />
                <BrandedNonBrandedWidgetWrapper
                    apiParams={apiParams}
                    apiParamsObj={apiParamsObj}
                    subtitleFilters={subtitleFilters}
                />
            </TopPageWidgetsRow>
        </div>
    );
};
